<template>
    <div class="outer-box" >
      <h4>Get verification code for email</h4>
  
      <div class="inner-box" style="text-align: left; width: 500px;">
        <input
          class="hl_input--wrap "
          type="text"
          placeholder="email"
          v-model="email"
        />
        <button class="btn btn-primary mt-4" @click="fetchEmailVerificationCode" :disabled="!email || processing">
          <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
          <span v-else> Fetch Verification Code </span>
        </button>
        <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{response}}</pre>
      </div>
    </div>
  </template>
  
  <script>
  import { OnboardingService } from "@/services";
  import * as moment from "moment";
  export default {
    data() {
      return {
        moment,
        email: '',
        processing: false,
        response: null
      };
    },
    methods: {
      async fetchEmailVerificationCode(){
        try {
            this.processing = true
            const {data} = await OnboardingService.fetchEmailVerificationCode(this.email);

            if(data.success) {
              this.response = {
                  otp: data.result.data.otp,
                  companyId: data.result.data.companyId,
                  verificationMode: data.result.data.verificationMode,
                  verificationValue: data.result.data.verificationValue,
                  createdAt: moment(data.result.data.createdAt).format('DD-MMM-YYYY HH:mm:ss Z'),
                  hasExpired: data.result.data.isExpire,
                }
            } else {
                this.response = data.message
            }

            this.processing = false;
        } catch (error) {
            this.processing = false;
            console.error(error);
        }
        
      },
    }
  }
  </script>
  
  <style>
  </style>
  